import { defineSingleMultiSelect } from '../utils/defineSingleMultiSelect';
export default {
  type: 'form',
  config: {
    afterDeserialize: function afterDeserialize(data) {
      // https://uniteus.atlassian.net/browse/TFF-85
      // Users should only be able to select one of the options for multi-select dropdowns when maxSelectedChoices=1,
      // since single-select dropdowns are not currently being migrated
      var newConfig = defineSingleMultiSelect(data);
      return newConfig;
    }
  }
};
//# sourceMappingURL=form.js.map